import * as React from 'react'
import { AlertDialogSlide } from '@sales-center/components'

type DeleteDialogProps = {
  matched: boolean
  open: boolean
  okClick: () => Promise<void>
  cancelClick: () => void
  okButtonDisabled?: boolean
}

export const DeleteDialog: React.FC<DeleteDialogProps> = (props) => {
  const { matched, ...rest } = props

  const action = matched ? 'Remove' : 'Delete'

  const title = `${action} Location`

  const message = `${
    matched ? 'Removing' : 'Deleting'
  } this location will remove associated services. Are you sure you want to ${action.toLowerCase()} this location?`

  return (
    <AlertDialogSlide
      {...rest}
      title={title}
      message={message}
      okButtonText={action}
    />
  )
}
DeleteDialog.displayName = 'DeleteDialog'
